import React from "react";
import { Badge } from "../ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { formatDate } from "./constants";

const prioColor = { critical: "bg-red-100 text-red-700", high: "bg-orange-100 text-orange-700", medium: "bg-amber-100 text-amber-700", low: "bg-slate-100 text-slate-600" };

export function ObligationsTab({ obligations, expanded, onUpdateStatus }) {
  return (
    <div className="space-y-3" data-testid="obligations-tab">
      <div className="flex justify-between items-center">
        <p className="text-sm text-slate-500">{obligations.length} obligation(s)</p>
        <div className="flex gap-2 text-[10px] text-slate-400">
          <span>{obligations.filter(o => o.status === "compliant" || o.status === "completed").length} compliant</span>
          <span>{obligations.filter(o => o.status === "non_compliant" || o.status === "overdue").length} non-compliant</span>
        </div>
      </div>
      {obligations.length === 0 ? (
        <p className="text-xs text-slate-400 text-center py-6">No obligations extracted yet. Use the Compliance page to extract obligations from this contract.</p>
      ) : (
        <div className={`space-y-2 overflow-y-auto ${expanded ? "max-h-[calc(100vh-350px)]" : "max-h-[400px]"}`}>
          {obligations.map((ob) => (
            <div key={ob.id} className="p-3 border rounded-sm space-y-1.5">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 flex-wrap flex-1 min-w-0">
                  <span className="text-sm font-medium">{ob.title}</span>
                  <Badge className={`rounded-sm text-[10px] ${prioColor[ob.priority] || prioColor.medium}`}>{ob.priority}</Badge>
                  <Badge variant="outline" className="text-[10px]">{ob.responsible_party === "internal" ? "Internal" : "Counterparty"}</Badge>
                </div>
                <Select value={ob.status || "pending"} onValueChange={(v) => onUpdateStatus("obligations", ob.id, { status: v })}>
                  <SelectTrigger className="rounded-sm h-7 w-32 text-[10px]" data-testid={`ob-status-${ob.id}`}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="pending">Pending</SelectItem>
                    <SelectItem value="in_progress">In Progress</SelectItem>
                    <SelectItem value="compliant">Compliant</SelectItem>
                    <SelectItem value="non_compliant">Non-Compliant</SelectItem>
                    <SelectItem value="completed">Completed</SelectItem>
                    <SelectItem value="overdue">Overdue</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <p className="text-xs text-slate-600">{ob.description}</p>
              <div className="flex items-center gap-4 text-[10px] text-slate-400">
                {ob.due_date && <span>Due: {formatDate(ob.due_date)}</span>}
                {ob.created_at && <span>Created: {formatDate(ob.created_at)}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
